export function formatWindDirection(degrees) {
  // 确保角度在0-360之间
  degrees = ((degrees % 360) + 360) % 360

  // 定义8个基本方位（每45度一个区间）
  const directions = ['北', '东北', '东', '东南', '南', '西南', '西', '西北']

  // 计算方位索引（将角度偏移22.5度后除以45取整）
  const index = Math.floor(((degrees + 22.5) % 360) / 45)

  return `${directions[index]}风`
}
